'use strict';

import React from 'react';

const Loader = ({ ...props }) => {
  return (
    <div className="ot-loader" {...props}>
      Loading...
    </div>
  );
};

export default Loader;
